/* eslint-disable import/no-anonymous-default-export*/
import {
  USER_LOADED,
  USER_LOADING,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT_SUCCESS,
} from "../actions/types";

const initialState = {
  token: null,
  isAuthenticated: null,
  isLoading: true,
  user: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case USER_LOADING:
      return {
        ...state,
        // isLoading: true,
      };
    case USER_LOADED:
      return {
        ...state,
        // isAuthenticated: true,
        // isLoading: false,
        // user: action.payload,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        token: action.payload.jwt,
        user: action.payload.user,
        // isAuthenticated: true,
        isLoading: false,
      };
    case AUTH_ERROR:
    case LOGIN_FAIL:
      return {
        ...state,
        token: null,
        user: null,
        isAuthenticated: false,
        isLoading: false,
      };

    case LOGOUT_SUCCESS:
      localStorage.removeItem("persist:evd");
      return {
        ...state,
        token: null,
        user: null,
        isLoading: false,
      };
    default:
      return state;
  }
}
